var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fieldset',{ref:"fieldset",attrs:{"legend":_vm.legend,"toggleable":_vm.toggleable,"collapsed":_vm.collapsed},scopedSlots:_vm._u([{key:"legend",fn:function(){return [_vm._t("legendSlot")]},proxy:true}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }